export default "__VITE_ASSET__BlGIPCp9__"